import React from 'react'

export default function EmailImg() {
  return (
    <div>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19 4.99023H5C3.89543 4.99023 3 5.88566 3 6.99023V16.9902C3 18.0948 3.89543 18.9902 5 18.9902H19C20.1046 18.9902 21 18.0948 21 16.9902V6.99023C21 5.88566 20.1046 4.99023 19 4.99023Z" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M3 6.99023L12 12.9902L21 6.99023" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

    </div>
  )
}
